var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconShareTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.362,
    height: 26.334,
    viewBox: "0 0 32.362 26.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-logo-twitter",
    "data-name": "Icon ionic-logo-twitter",
    d: "M33.775,7.62A13.423,13.423,0,0,1,29.962,8.67a6.663,6.663,0,0,0,2.921-3.676,13.193,13.193,0,0,1-4.218,1.612,6.637,6.637,0,0,0-11.487,4.54,6.5,6.5,0,0,0,.171,1.516A18.816,18.816,0,0,1,3.663,5.714a6.653,6.653,0,0,0,2.064,8.874,6.485,6.485,0,0,1-3.017-.83v.082a6.645,6.645,0,0,0,5.328,6.515,6.683,6.683,0,0,1-1.749.233,6.263,6.263,0,0,1-1.248-.123,6.65,6.65,0,0,0,6.206,4.615A13.312,13.312,0,0,1,3,27.926a13.458,13.458,0,0,1-1.584-.1,18.558,18.558,0,0,0,10.163,3C23.8,30.834,30.483,20.7,30.483,11.92c0-.288-.007-.576-.021-.857A13.516,13.516,0,0,0,33.775,7.62Z",
    transform: "translate(-1.413 -4.5)",
    fill: "#fc6e00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShareTwitter);
export default __webpack_public_path__ + "static/media/icon-share-twitter.aa79979b17654a822af0a066e773fd8f.svg";
export { ForwardRef as ReactComponent };